export const COPY_WISHLIST_STATUS_PARAM = "copySuccess";
export const REMOVED_ITEMS = "itemsRemoved";
